import { 
  SUBMIT_RFI_SUPPORT_TICKET_INIT, 
  SUBMIT_RFI_SUPPORT_TICKET_SUCCESS, 
  SUBMIT_RFI_SUPPORT_TICKET_ERROR,
  SUBMIT_RFI_SUPPORT_TICKET_RESET
} from '../actions/rfi-support';

const initialState = {
  error: null,
  success: false,
  loading: false,
};

const supportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_RFI_SUPPORT_TICKET_INIT:
      return {
        ...state,
        error: null,
        success: false,
        loading: true,
      };
    case SUBMIT_RFI_SUPPORT_TICKET_SUCCESS:
      return {
        ...state,
        error: null,
        success: true,
        loading: false,
      };
    case SUBMIT_RFI_SUPPORT_TICKET_ERROR:
      return {
        ...state,
        error: action.error || 'Error',
        success: false,
        loading: false,
      };
    case SUBMIT_RFI_SUPPORT_TICKET_RESET:
      return {
        ...state,
        error: null,
        success: false,
        loading: false,
      };
    default:
      return state;
  }
};

export default supportReducer;